<template>
  <q-pull-to-refresh @refresh="refresh">
    <q-card flat>
      <q-card-section class="no-padding">
        <q-banner class="bg-blue text-white">
          تقویم مطالبات
        </q-banner>
      </q-card-section>
      <q-card-section class="no-padding" align="center">
        <q-date
            range
            @input="showDetails"
            bordered
            class="q-ma-sm"
            calendar="persian"
            today-btn
            v-model="selectedDate"
            :events="itemsOptions.filter(item=> item.FactorType===1).map(item=> item.Money_Maturity_Date)"
            event-color="red"
            :landscape="!$q.screen.lt.md">
        </q-date>
        <q-card-section align="center">
          <div class="row flex flex-center">
            <div class="col-md-4 col-xs-12">
              <q-select filled
                        label="جستجو بر حسب طرف معامله..."
                        v-model="searchCustomer"
                        :options="customerListOptions"
                        option-value="Cs_ID"
                        option-label="Cs_Name"
                        use-input
                        use-chips
                        multiple
                        @filter="filterFn"
              />
            </div>
          </div>
        </q-card-section>
        <q-space/>
        <q-chip square color="indigo" text-color="white" v-if="details && details.length>0" label="تعداد کل">
          <q-badge floating rounded :label="details.length" color="red" text-color="white"/>
        </q-chip>
        <q-chip square color="indigo" text-color="white" v-if="itemsOptions && itemsOptions.length>0 &&
        $store.state.roles.some(v=>['admin','can_sea_goods_profit'].includes(v))" label="جمع کل اختلاف با خرید">
          <q-badge class="q-ml-xs" :label="lodash.sumBy(details, 'DiffPay').toLocaleString()" color="red"
                   text-color="white"/>
        </q-chip>
        <q-space/>
        <q-chip
            v-if="goodsItems.length>0 && $store.state.roles.some(v=>['admin','can_see_goods_group_info_in_deboters'].includes(v))"
            square label="گروه کالاهای تسویه شده" color="indigo"
            text-color="white" clickable icon="analytics" @click="goodsinfoDialog=true">
          <q-badge color="red" text-color="white" :label="goodsItems.length" rounded floating/>
        </q-chip>
        <q-chip
            v-if="goodsItemsNotPass.length>0 && $store.state.roles.some(v=>['admin','can_see_goods_group_info_in_deboters'].includes(v))"
            square label="گروه کالاهای تسویه نشده" color="indigo"
            text-color="white" clickable icon="analytics" @click="goodsinfoDialogNotPass=true">
          <q-badge color="red" text-color="white" :label="goodsItemsNotPass.length" rounded floating/>
        </q-chip>
        <q-space/>
        <q-chip square color="indigo" text-color="white" v-if="detailsNotPass && detailsNotPass.length>0"
                label="تسویه شده">
          <q-badge class="q-ml-xs" :label="lodash.sumBy(detailsNotPass, 'Sale_PayReceive').toLocaleString()" color="red"
                   text-color="white"/>
        </q-chip>
        <q-chip square color="indigo" text-color="white" v-if="details && details.length>0" label="تسویه نشده">
          <q-badge class="q-ml-xs" :label="lodash.sumBy(details, 'Sale_Pay').toLocaleString()" color="red"
                   text-color="white"/>
        </q-chip>
        <q-chip square color="indigo" text-color="white" v-if="checkList && checkList.length>0" label="چک">
          <q-badge class="q-ml-xs" :label="lodash.sumBy(checkList, 'Fee').toLocaleString()" color="red"
                   text-color="white"/>
        </q-chip>

        <q-space/>
        <div class="row flex flex-center" v-if="details && details.length>0">
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div class="text-subtitle1">
              لیست فاکتورهای تسویه نشده
            </div>
            <q-separator/>
            <FinancialClaimsItems :items="itemsOptions" :details="details" @refresh-data="loadData"
                                  @customer-details="loadCustomerData"
                                  @added-pay="payAdded"/>
          </div>
        </div>
        <div class="row flex flex-center" v-if="detailsNotPass && detailsNotPass.length>0">
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div class="text-subtitle1">
              لیست فاکتورهای تسویه شده
            </div>
            <q-separator/>
            <FinancialClaimsItems :items="itemsOptions" :details="detailsNotPass" @refresh-data="loadData"
                                  @customer-details="loadCustomerData"
                                  @added-pay="payAdded"/>
          </div>
        </div>

        <div class="row flex flex-center" v-if="checkList && checkList.length>0">
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div class="text-subtitle1">
              لیست چک ها
            </div>
            <q-separator/>
            <CheckNotPassed :items="checkList"/>
          </div>
        </div>
      </q-card-section>
    </q-card>

    <q-dialog :maximized="$q.screen.lt.md" v-model="showCustomerFactors">
      <FinancialClaimsItems @added-pay="payAdded" :is-dialog="true" :items="items" :details="detailsCustomer"
                            @refresh-data="loadData"/>
    </q-dialog>

    <q-dialog maximized v-model="goodsinfoDialog">
      <FinancialClaimsGoodsInfo :items="goodsItems" title="گروه کالاهای تسویه شده" :passed="true"
                                :start-date="startDate" :end-date="endDate"/>
    </q-dialog>
    <q-dialog maximized v-model="goodsinfoDialogNotPass">
      <FinancialClaimsGoodsInfo :start-date="startDate" :end-date="endDate" :items="goodsItemsNotPass"
                                title="گروه کالاهای تسویه نشده" :passed="false"/>
    </q-dialog>
  </q-pull-to-refresh>
</template>

<script>
import {mapActions} from "vuex";
import FinancialClaimsItems from "@/components/Deboters/FinancialClaimsItems";
import FinancialClaimsGoodsInfo from "@/components/Deboters/FinancialClaimsGoodsInfo";
import CheckNotPassed from "@/components/customers/CheckNotPassed";

export default {
  name: "FinancialClaims",
  components: {CheckNotPassed, FinancialClaimsGoodsInfo, FinancialClaimsItems},
  data() {
    return {
      goodsinfoDialogNotPass: false,
      customerList: [],
      customerListOptions: [],
      searchCustomer: null,
      showCustomerFactors: false,
      items: [],
      itemsOptions: [],
      goodsItems: [],
      details: [],
      detailsNotPass: [],
      selectedDate: this.ToJalaliDate(new Date()),
      detailsCustomer: [],
      goodsinfoDialog: false,
      checkList: [],
      goodsItemsNotPass: [],
      startDate: '',
      endDate: ''
    }
  },
  methods: {
    ...mapActions({
      setList: 'Dashboard/getListOfFinancialClaims',
      setGoodsList: 'Dashboard/getListOfFinancialClaimsGoods',
    }),
    payAdded(args) {
      if (args.length > 0) {
        this.details = this.details.filter(item => parseInt(item.Sale_Num) !== parseInt(args[0].Sale_Num))
        this.detailsNotPass.push(args[0])
      }

    },
    filterFn(val, update) {
      if (val.toString().trim() === '') {
        update(() => {
          this.customerListOptions = this.customerList
        })
        return
      }

      update(() => {
        const needle = val
        this.customerListOptions = this.customerList.filter(v =>v.Cs_Name && v.Cs_Name.indexOf(needle) > -1)
      })
    },
    loadCustomerData(row) {
      this.detailsCustomer = this.items.filter(item => item.Cs_ID === row.Cs_ID)
      this.showCustomerFactors = true
    },
    showDetails(value) {
      if (value) {
        if (value.from !== undefined) {
          this.details = this.itemsOptions.filter(
              item => (this.ToGregorianDateTime(item.Money_Maturity_Date) >= this.ToGregorianDateTime(value.from)) &&
                  (this.ToGregorianDateTime(item.Money_Maturity_Date) <= this.ToGregorianDateTime(value.to))
                  && item.FactorType === 1)

          this.detailsNotPass = this.itemsOptions.filter(
              item => (this.ToGregorianDateTime(item.Money_Maturity_Date) >= this.ToGregorianDateTime(value.from)) &&
                  (this.ToGregorianDateTime(item.Money_Maturity_Date) <= this.ToGregorianDateTime(value.to))
                  && item.FactorType === 2)

          this.checkList = this.$store.state.checkList.filter(
              item => parseInt(item.ExpiryDate) >= parseInt(value.from.replaceAll('/', ''))
                  && parseInt(item.ExpiryDate) <= parseInt(value.to.replaceAll('/', ''))
          )
        } else {
          this.details = this.itemsOptions.filter(item => item.Money_Maturity_Date === this.selectedDate && item.FactorType === 1)
          this.detailsNotPass = this.itemsOptions.filter(item => item.Money_Maturity_Date === this.selectedDate && item.FactorType === 2)

          this.checkList = this.$store.state.checkList.filter(
              item => item.ExpiryDate === parseInt(value.replaceAll('/', '')))
        }
      }
    },
    refresh(done) {
      setTimeout(() => {
        this.loadData().then(() => {
          done()
        })
      }, 1000)
    },
    async loadData() {
      this.startDate = this.selectedDate.from ? this.selectedDate.from : this.selectedDate
      this.endDate = this.selectedDate.to ? this.selectedDate.to : this.selectedDate
      await this.setList().then((res) => {
        this.items = res;
        this.itemsOptions = this.items;
        this.details = this.itemsOptions.filter(item => item.Money_Maturity_Date === this.selectedDate && item.FactorType === 1)
        this.detailsNotPass = this.itemsOptions.filter(item => item.Money_Maturity_Date === this.selectedDate && item.FactorType === 2)
      })
      await this.setGoodsList({
        startDate: this.startDate,
        endDate: this.endDate
      }).then((res) => {
        this.goodsItems = res.filter(item => item.Sale_PayReceive ?? 0 === parseInt(item.SaleG_Pay));
        this.goodsItemsNotPass = res.filter(item => item.Sale_PayReceive ?? 0 !== parseInt(item.SaleG_Pay));
      })
      this.checkList = this.$store.state.checkList.filter(item => item.ExpiryDate === this.getTodayDateJalali().replaceAll('/', ''))
      this.customerList = this.lodash.uniqBy(this.itemsOptions, 'Cs_ID')
      this.customerListOptions = this.customerList;
    }
  },
  watch: {
    searchCustomer: function (newValue) {
      if (newValue.length > 0) {
        const Ids = newValue.map(item => item.Cs_ID)
        this.itemsOptions = this.items.filter(item => Ids.includes(item.Cs_ID))
      } else {
        this.itemsOptions = this.items;
      }
      this.details = this.itemsOptions.filter(item => item.Money_Maturity_Date === this.selectedDate && item.FactorType === 1)
      this.detailsNotPass = this.itemsOptions.filter(item => item.Money_Maturity_Date === this.selectedDate && item.FactorType === 2)
    },
    selectedDate: function (value) {
      if (value) {
        this.startDate = this.selectedDate.from ? this.selectedDate.from : this.selectedDate
        this.endDate = this.selectedDate.to ? this.selectedDate.to : this.selectedDate

        if (this.startDate === this.endDate) {
          this.details = this.itemsOptions.filter(item => item.Money_Maturity_Date === this.selectedDate && item.FactorType === 1)
          this.detailsNotPass = this.itemsOptions.filter(item => item.Money_Maturity_Date === this.selectedDate && item.FactorType === 2)
        }

        this.setGoodsList({
          startDate: this.startDate,
          endDate: this.endDate
        }).then((res) => {
          this.goodsItems = res.filter(item => parseInt(item.Sale_PayReceive ?? 0) === parseInt(item.SaleG_Pay));
          this.goodsItemsNotPass = res.filter(item => parseInt(item.Sale_PayReceive ?? 0) !== parseInt(item.SaleG_Pay));
        })
      } else {
        this.goodsItem = []
      }
    }
  },
  created() {
    this.loadData()
  }
}
</script>

<style scoped>

</style>